export default __webpack_public_path__ + "static/media/thumb_2_fs.dbef12cc.png";